var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgApp = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.75 2H6.25A1.25 1.25 0 0 0 5 3.25v17.5A1.25 1.25 0 0 0 6.25 22h11.5A1.25 1.25 0 0 0 19 20.75V3.25A1.25 1.25 0 0 0 17.75 2ZM12 21a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 12 21Zm5-5.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5Z"
})));
export default SvgApp;